export const LOAD_TOUR_LIST = 'LOAD_TOUR_LIST'
export const LOAD_SERVICE_LIST = 'LOAD_SERVICE_LIST'

const state = {
  tourList: [],
  serviceList: []
}

const getters = {
  getTourList: state => {
    return [...state.tourList]
  },
  getServiceList: state => {
    return [...state.serviceList]
  }
}

const mutations = {
  [LOAD_TOUR_LIST] (state, payload) {
    const {list, configs} = payload
    if (list) {
      list.forEach(item => {
        item.config = configs.find(tour => {
          return tour.codice === item.element.productID
        })
      })
      state.tourList = [...list]
    } else {
      state.tourList = []
    }
  },
  [LOAD_SERVICE_LIST] (state, payload) {
    if (payload) {
      state.serviceList = [...payload]
    }
  }
}

const actions = {
  loadTourList ({ commit, state, rootGetters }, list) {
    commit(LOAD_TOUR_LIST, {list, configs: rootGetters.getTours.list})
  },
  loadServiceList ({ commit, state }, item) {
    commit(LOAD_SERVICE_LIST, item)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/front/store/modules/lists.js